import { useEffect, useState } from "react";
import PopupModal from "./PopupModal";
import { isMobileView } from "./CommonFunctions";

const InfoModal = ({ type, setPopUp,width="w-[30vw]" }) => {
  const [title, setTitle] = useState("");
  const [points, setPoints] = useState([]);

  useEffect(() => {
    if (type === "ProductInventory") {
      setTitle("Inventory Info");
      setPoints([
        {
          title: "FIFO (First In – First Out)",
          meaning: "The products you bought first are sold first.",
          whyUseful:
            "Helps in keeping old stock moving, avoids expired or outdated products staying in storage.",
          bestFor:
            "Grocery stores, supermarkets, pharmacies (milk, bread, medicines – sell older stock first).",
          example:
            "If you buy 10 milk packets today and 10 more tomorrow, the system will sell today’s 10 packets first.",
        },
        {
          title: "Unique No",
          meaning:
            "Each product or service gets a unique identification number (like a code).",
          whyUseful: "Easy to track and manage products individually.",
          bestFor:
            "Electronics, appliances, jewelry, services (where each item has a serial number or code).",
          example:
            "A mobile phone with IMEI number or a gold chain with a unique tag.",
        },
        {
          title: "Variants",
          meaning: "Same product but in different options like size, color, or type.",
          whyUseful:
            "Makes it easy to manage multiple versions of the same product under one product name.",
          bestFor: "Clothing, shoes, cosmetics, accessories.",
          example:
            "A T-shirt in sizes S, M, L, XL or a lipstick available in Red, Pink, and Nude shades.",
        },
        {
          title: "Batch Tracking",
          meaning:
            "Products are tracked based on their batch number, manufacturing date, and expiry date.",
          whyUseful:
            "Important for products that expire or need quality tracking.",
          bestFor: "Medicine shops, food products, cosmetics, chemicals.",
          example:
            "A batch of medicines manufactured in January with expiry in December – helps sell before expiry.",
        },
      ]);
    }else if(type=="NewPrintConfig"){
    setTitle("Print Configuration Info");
    setPoints([

  {
    title: "Print Display Name",
    meaning:
      "Enter a display name for this print template. This name appears in dropdowns like Sales or Purchase print options.",
    whyUseful:
      "Helps you easily identify templates instead of using store code or dummy names like 'Offline Test'.",
    bestFor:
      "Retail stores, supermarkets, or any business where multiple print templates are used.",
    example: "'Retail Invoice', 'Thermal Print', etc.",
  },
  {
    title: "Header Title",
    meaning: "Enter the main title that appears at the top of your printed document. This is the primary heading that identifies the document type.",
    whyUseful: "Clearly communicates the purpose of the document to customers and helps distinguish between different types of transactions at a glance.",
    bestFor: "All businesses that issue printed documents to customers, especially those needing to differentiate between sales invoices, tax invoices, receipts, or quotations.",
    example: "'Sales Invoice', 'Tax Invoice', 'Purchase Entry','Sales Order'"
},
  {
    title: "Header",
    meaning: "Add text or an image at the top of your print template.",
    whyUseful:
      "Allows branding and important information to appear at the top of invoices or receipts.",
    bestFor: "Any business that wants logos or headings in prints.",
    example:
      "Header Text: 'Company Name', Header Image: Logo of the store.",
  },
  {
    title: "Footer",
    meaning: "Add custom text, image, or signature at the bottom of the print.",
    whyUseful:
      "Useful for thank-you notes, QR codes, or official signatures on documents.",
    bestFor: "Stores, offices, pharmacies, or any business needing footer info.",
    example:
      "Footer Text: 'Thank you for your business', Footer Image: QR code, Signature: Authorized signatory.",
  },
  {
    title: "Store Information To Be Printend",
    meaning: "Select which store details to display (Name, Address, Phone, etc).",
    whyUseful:
      "Ensures customers see the correct store information on invoices or receipts.",
    bestFor: "Multi-store setups where each store has different details.",
    example:
      "Instead of 'Phone No', show 'Mobile No: 87478966'. Include Store Name and Address.",
  },
  {
    title: "Customer Information To Be Printend",
    meaning: "Select which customer details to display (Name, Phone, Email, etc).",
    whyUseful:
      "Personalizes the print for the customer and allows label customization.",
    bestFor: "Retailers, service providers, or any business with customer transactions.",
    example:
      "Show 'Client Name' instead of 'Customer Name', display Email or Phone No as needed.",
  },
    {
    title: "Vendor Information To Be Printend",
    meaning: "Select which vendor details to display (Name, Phone, Email, etc).",
    whyUseful:
      "Personalizes the print for the vendor and ensures purchase/order clarity.",
    bestFor: "Retailers, wholesalers, or any business dealing with vendor transactions.",
    example:
      "Show 'Supplier Name' instead of 'Vendor Name', display Email or Phone No as needed.",
  },
  {
    title: "Transaction Details",
    meaning: "Choose which transaction info appears on the print (Invoice No, Date, etc).",
    whyUseful:
      "Customizes what details are visible on receipts or invoices.",
    bestFor: "All businesses needing clear transaction info on prints.",
    example: "Show 'Bill Date' instead of 'Date', include Invoice Number, Payment Method.",
  },
    {
    title: "Print Orientation",
    meaning: "Choose whether the print should be in Portrait or Landscape mode.",
    whyUseful: "Ensures the print fits properly on the paper and is easy to read.",
    bestFor: "All businesses needing correct page layout for invoices, bills, or reports.",
    example: "Select 'Portrait' for standard invoices or 'Landscape' for wider formats like product lists.",
  },
  {
  title: "Print Height",
  meaning: "Set the height of the print area for your template in pixels (px).",
  whyUseful: "Controls how much content fits on one page and prevents content cutoff.",
  bestFor: "Stores using thermal printers or custom-sized paper for digital or receipt printing.",
  example:
    "1 mm ≈ 3.78 px. For example, a receipt 80 mm tall = 80 × 3.78 ≈ 302 px. " +
    "A4 paper 297 mm tall = 297 × 3.78 ≈ 1122 px. Adjust print height accordingly.",
}

  
]);

    }
       else if (type === "BarcodeSettings") {
      setTitle("Barcode Settings Information");
      setPoints([
        {
          title: "Page Settings",
          meaning: "Controls the overall layout and positioning of labels on the sheet.",
          whyUseful: "Ensures your labels print correctly without being cut off and align properly on the page.",
          bestFor: "All businesses using label printers for products, inventory, or shipping.",
          example: "",
        },
        {
          title: "Left Margin (mm) / Top Margin (mm)",
          meaning: "Controls the spacing from the left/top edge of the paper to where printing begins.",
          whyUseful: "Prevents content from being printed too close to the edge of the paper.",
          bestFor: "All label printing scenarios.",
          example: "Typically 5-10mm for most printers.",
        },
        {
          title: "Default Printer Margins",
          meaning: "Printer-specific margins that override the general settings.",
          whyUseful: "Fine-tunes printing alignment for your specific printer model.",
          bestFor: "When labels aren't aligning properly with general margin settings.",
          example: "Consult your printer manual for recommended values.",
        },
        {
          title: "No of Columns / No of Rows",
          meaning: "Defines how many labels are arranged horizontally (columns) and vertically (rows) on each sheet.",
          whyUseful: "Matches the physical layout of your label sheets.",
          bestFor: "Standard label sheets like A4 with 3×8 labels.",
          example: "3 columns × 8 rows for standard A4 label sheets.",
        },
        {
          title: "Margin Between Field (mm)",
          meaning: "Controls spacing between different data fields on the same label.",
          whyUseful: "Improves readability and prevents information from overlapping.",
          bestFor: "Labels with multiple information fields.",
          example: "Increase for better readability, decrease to fit more information.",
        },
        {
          title: "Label Settings",
          meaning: "Controls the appearance and layout of individual labels.",
          whyUseful: "Ensures your labels are properly sized and formatted for your specific needs.",
          bestFor: "Custom label sizes and specialized printing requirements.",
          example: "",
        },
        {
          title: "Label Width (mm) / Height (mm)",
          meaning: "Defines the physical dimensions of each individual label.",
          whyUseful: "Matches the exact size of your labels for perfect printing.",
          bestFor: "All label printing scenarios.",
          example: "Precisely measure your labels and enter those values here.",
        },
        {
          title: "Margins Inside Label",
          meaning: "Controls spacing from the label edges to where content begins.",
          whyUseful: "Prevents content from printing too close to label edges.",
          bestFor: "Ensuring barcodes and text remain fully within label boundaries.",
          example: "Typically 2-5mm depending on label size.",
        },
        {
          title: "Horizontal/Vertical Space",
          meaning: "Controls spacing between multiple labels on a sheet.",
          whyUseful: "Matches the gap between labels on your label sheets.",
          bestFor: "Sheets with pre-cut labels.",
          example: "Typically matches the gap between labels on your label sheets.",
        },
        {
          title: "No of Character",
          meaning: "Limits the number of characters displayed in text fields.",
          whyUseful: "Prevents long text from overflowing the label space.",
          bestFor: "Product names or descriptions that might be too long for labels.",
          example: "Set to 20-25 characters for most standard labels.",
        },
        {
          title: "Barcode Height",
          meaning: "Controls the vertical size of the barcode.",
          whyUseful: "Taller barcodes are easier to scan but take more space.",
          bestFor: "Ensuring barcodes are scannable by all types of scanners.",
          example: "20-25mm is typically good for most applications.",
        },
        {
          title: "Bar Width Scale",
          meaning: "Controls the thickness of barcode lines.",
          whyUseful: "Thicker lines may be easier to scan but take more space.",
          bestFor: "Fine-tuning barcode appearance for different scanning equipment.",
          example: "Values between 1-3 typically work best.",
        },
        {
          title: "Label Positioning",
          meaning: "Choose between automatic or manual field placement.",
          whyUseful: "Auto positioning is faster, manual allows precise control.",
          bestFor: "Auto for standard layouts, manual for custom label designs.",
          example: "Auto: System automatically arranges fields. Manual: Precisely position each field.",
        },
        {
          title: "Barcode Value",
          meaning: "Select which product identifier to encode in the barcode.",
          whyUseful: "Determines what information is stored in the barcode itself.",
          bestFor: "SKU for internal tracking, Barcode for universal product codes.",
          example: "SKU: Uses your internal product code. Barcode: Uses manufacturer's barcode (UPC/EAN).",
        },
        {
          title: "Fields to be Printed",
          meaning: "Choose which product information appears on labels.",
          whyUseful: "Customizes the information displayed on your labels.",
          bestFor: "Tailoring labels to specific needs (inventory, pricing, etc.).",
          example: "Typically include SKU, Name, and Price for product identification.",
        },
        {
          title: "Display Name",
          meaning: "Customize how field names appear on labels.",
          whyUseful: "Allows for abbreviated or customized field names to save space.",
          bestFor: "When standard field names are too long for your labels.",
          example: "Shorten 'Retail Price' to just 'Price' to save space.",
        },
        {
          title: "Font Style",
          meaning: "Control text appearance (normal or bold).",
          whyUseful: "Emphasizes important information on the label.",
          bestFor: "Making prices or important identifiers stand out.",
          example: "Normal: Regular text. Bold: Emphasized text for important info.",
        },
        {
          title: "Font Size (mm)",
          meaning: "Control text size on the label.",
          whyUseful: "Ensures text is readable without taking too much space.",
          bestFor: "Balancing readability with space constraints.",
          example: "Larger text is more readable but takes more space.",
        },
        {
          title: "Position",
          meaning: "Determine where field appears relative to barcode.",
          whyUseful: "Organizes information logically on the label.",
          bestFor: "Creating a consistent, readable label layout.",
          example: "Above barcode: Best for product identifiers. Below barcode: Best for pricing information.",
        },
        {
          title: "Sequence",
          meaning: "Control the order in which fields appear.",
          whyUseful: "Organizes information in a logical flow.",
          bestFor: "Ensuring the most important information is seen first.",
          example: "Number fields in the order you want them displayed (1 = first, 2 = second, etc.).",
        },
        {
          title: "X Position / Y Position",
          meaning: "Precisely position fields using coordinates (manual mode only).",
          whyUseful: "Allows pixel-perfect placement of each field.",
          bestFor: "Custom label designs with specific layout requirements.",
          example: "Measure from the top-left corner of the label in millimeters.",
        },
      ]);
    }
     else if (type === "OfflineBilling") {
      setTitle("Why Use Offline Billing ?");
      setPoints([
        "Lets you continue billing customers even if your internet goes down.",
        "Bills are saved safely on your computer/device.",
        "As soon as the internet comes back, all bills automatically sync to the server.",
        "No waiting for internet – keep serving customers without interruption.",
        "Prevents loss of sales during network issues.",
        "Works seamlessly – the shop owner doesn’t need to do anything extra.",
        "Example: If your shop Wi-Fi stops working while billing, you can still create bills and they’ll sync later when online.",
      ]);
    }
     else if (type === "ProductUOM") {
      setTitle("Unit of Measurement (UOM) Info");
      setPoints([
        {
          title: "Why this section is needed",
          meaning:
            "To avoid confusion in billing and stock management. Helps when products are bought in one unit but sold in another. Keeps inventory accurate across purchases and sales.",
        },
        {
          title: "Primary UOM",
          meaning: "The main unit you use to track stock.",
          example: "Bags, Pieces, Litres, Kilograms.",
        },
        {
          title: "Secondary UOM",
          meaning: "An alternative way of measuring the same product.",
          example: "1 Bag = 50 Kg, 1 Box = 12 Pieces.",
        },
        {
          title: "Conversion",
          meaning: "The system automatically converts between units.",
          example:
            "If 1 Box = 12 Pieces, when you sell 2 Boxes, stock reduces by 24 Pieces.",
        },
        {
          title: "Default Sales UOM",
          meaning: "The unit in which you usually sell to customers.",
          example: "You buy Rice in Quintals but sell in Kg.",
        },
        {
          title: "Default Purchase UOM",
          meaning: "The unit in which you usually purchase from suppliers.",
          example: "You purchase Milk in Litres but sell in Packets.",
        },
        {
          title: "Where this is required (Industries)",
          meaning: `Grocery Stores / Supermarkets – Rice (purchase in Quintals, sell in Kg), Oil (purchase in Litres, sell in 500ml packets).
Wholesale & Distribution – Buy in Cartons, sell in Pieces.
Clothing / Apparel – Sell in Pieces but stock may come in Dozens.
Pharmacy – Buy in Boxes (100 tablets), sell in Strips or Tablets.
Hardware & Construction – Cement (Bags to Kg), Steel (Ton to Kg).
Restaurants / Food Service – Ingredients measured in Kg or Litres, sold as Dishes/Plates.`,
        },
      ]);
    }
    else if (type === "ProductAdditionalInformation") {
      setTitle("Additional Information");
      setPoints([
  "This section lets you add up to 6 extra fields for products and services.",
  "It is flexible – you can use it for any detail that is not already covered in the standard fields (price, inventory, UOM, variants, etc.).",
  "Every business is different – some products or services need special details.",
  "Custom fields let you record and track unique information important for your shop.",
  "Keeps everything in one place instead of maintaining separate notes or spreadsheets.",
  "Examples of how shop owners can use it (per industry):",
  "Electronics / Appliances – Warranty Period, Model No., Power Consumption, Serial No.",
  "Pharmacy / Healthcare – Doctor’s Prescription Required, Storage Condition, Generic Name.",
  "Clothing / Fashion – Fabric Type, Wash Care Instructions, Style Code.",
  "Jewelry / Accessories – Purity (22K/18K), Weight in grams, Certification Number.",
  "Grocery / Food – Organic/Non-Organic, Brand Name, FSSAI Number, Storage Temperature.",
  "Services – Service Duration, Technician Assigned, Special Instructions.",
]);
    }
    else if(type==="StoreAdditionalInformation"){
      setTitle("Additional Information");
      setPoints([
  "The Store Custom Fields allow you to add additional business information that can appear on your printed invoices, receipts, or store details.",
  "You can use these fields to display registration numbers, branch details, or any other custom notes relevant to your business.",
  "All fields are completely optional and flexible - you can enter any information you want to display on your business documents.",
  "Example uses for each field (you can customize as needed):",
  "Custom Field 1: GSTIN Number, Business Registration ID, Trade License Number",
  "Custom Field 2: FSSAI License, CIN, PAN, MSME Registration Number",
  "Custom Field 3: Store Tagline, Branch Name, Operating Hours, Return Policy",
  "Custom Field 4: Support Email, Helpline Number, WhatsApp Contact, Store Address",
  "Custom Field 5: UPI ID, Bank Account Details, Payment Instructions, Terms",
  "Custom Field 6: Thank You Note, Feedback Request, Discount Coupon Code, Warranty Info",
  "Remember: These are just suggestions - you can use each field for any type of information that's important for your business.",
  "The information you enter will be displayed on invoices, receipts, and print templates for your customers."
]);
    }
  }, [type]);
  

  return (
    <PopupModal
      setPopUp={setPopUp}
      size={`${isMobileView() ? "w-[100%] h-[100%]" : `${width} max-h-[95vh]`} `}
      saveClick={() => {}}
      handleClose={() => {}}
      buttons={false}
      title={title}
    >
      <div className="space-y-4 text-sm leading-relaxed">
        {points.map((point, idx) =>
          typeof point === "string" ? (
            <ul
              key={idx}
              className="list-disc ml-6 space-y-2 text-sm leading-relaxed"
            >
              <li>{point}</li>
            </ul>
          ) : (
            <div key={idx} className="border-b pb-2 border-dotted last:border-none">
              <h5 className="font-semibold text-gray-900">{point.title}</h5>
             {point?.meaning && <p>
                <span className="font-medium">Meaning: </span>
                {point.meaning}
              </p>}
               {point?.whyUseful && <p>
                <span className="font-medium">Why useful: </span>
                {point.whyUseful}
              </p>}
             {point?.bestFor && <p>
                <span className="font-medium">Best for: </span>
                {point.bestFor}
              </p>}
                 {point?.example && <p>
                <span className="font-medium">Example: </span>
                {point.example}
              </p>}
            </div>
          )
        )}
      </div>
    </PopupModal>
  );
};

export default InfoModal;
